/**
 * Important, do not import any packages from @tiptap in this file
 * TipTap is a massive package we don't want in our main bundle!
 */

import { isEqual } from 'radash';

type TipTapNode = {
    type?: string;
    text?: string;
    content?: TipTapNode[];
};

const TipTapHelpers = {
    hasContent: (content: object | null = null) => {
        if (!content) {
            return false;
        }

        const empty = {
            content: [{ type: 'paragraph' }],
            type: 'doc',
        };

        return !isEqual(content, empty);
    },

    getText: (content: { content?: string | null; blockType?: string }[]): string => {
        if (!content?.length) return '';
        try {
            return content
                .filter((item): item is { content: string } => typeof item.content === 'string')
                .map((item) => extractText(JSON.parse(item.content)))
                .join('\n')
                .trim();
        } catch {
            return '';
        }
    },

    getTextFragments: (node: TipTapNode): string[] => {
        if (node.type === 'text') return [node.text ?? ''];

        return (node.content ?? []).flatMap(TipTapHelpers.getTextFragments);
    },
};

const extractText = (node: any): string => {
    if (node.type === 'text') return node.text || '';
    if (node.type?.startsWith('mention')) return node.attrs?.label ? `@${node.attrs.label}` : '';

    const blockTypes = ['paragraph', 'heading', 'listItem', 'codeBlock'];
    const separator = blockTypes.includes(node.type) ? '\n' : '';

    if (node.content) return node.content.map(extractText).join(separator);
    return '';
};

export { TipTapHelpers };
